import UserService from './services/userService';

export const onSignIn = (Login, Password, env) => UserService.auth(Login, Password, env);

export const onSignOut = () => new Promise((resolve) => {
  localStorage.clear();
  sessionStorage.clear();
  resolve();
});

export const isSignedIn = () => {
  const token = UserService.getToken();
  if (token !== null) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/Auth.js